import { AsYouType, CountryCode, getCountryCallingCode } from 'libphonenumber-js';

export const callingCodeOf = (country: CountryCode): string => String(getCountryCallingCode(country));

export const formatNational = (country: CountryCode, national: string): string => {
  if (!national) return '';
  const code = callingCodeOf(country);
  if (code === '1') {
    if (national.length < 3) return national;
    const area = `(${national.slice(0, 3)})`;
    if (national.length === 3) return area;
    if (national.length <= 6) return `${area} ${national.slice(3)}`;
    return `${area} ${national.slice(3, 6)}-${national.slice(6)}`;
  }
  const shown = new AsYouType().input(`+${code}${national}`);
  return shown.replace(new RegExp(`^\\+${code}\\s*`), '');
};

export const countDigitsBefore = (value: string, caret: number): number =>
  value.slice(0, caret).replace(/\D+/g, '').length;

export const caretIndexForDigits = (formatted: string, digits: number): number => {
  const total = formatted.replace(/\D+/g, '').length;
  if (digits <= 0) return 0;
  if (digits >= total) return formatted.length;
  let seen = 0;
  for (let i = 0; i < formatted.length; i += 1) {
    if (/\d/.test(formatted[i])) seen += 1;
    if (seen === digits) return i + 1;
  }
  return formatted.length;
};

export interface IDigitEdit {
  digits: string;
  caretDigits: number;
}

export const deleteAcrossSeparator = (
  value: string,
  selectionStart: number,
  key: 'Backspace' | 'Delete',
  selectionEnd: number = selectionStart,
): IDigitEdit | null => {
  if (selectionStart !== selectionEnd) return null;
  const digits = value.replace(/\D+/g, '');
  const before = countDigitsBefore(value, selectionStart);
  if (key === 'Backspace') {
    const previous = value[selectionStart - 1];
    if (previous === undefined || /\d/.test(previous) || before === 0) return null;
    return { digits: digits.slice(0, before - 1) + digits.slice(before), caretDigits: before - 1 };
  }
  const next = value[selectionStart];
  if (next === undefined || /\d/.test(next) || before >= digits.length) return null;
  return { digits: digits.slice(0, before) + digits.slice(before + 1), caretDigits: before };
};
